// Shared validation rules for forms (used by react-hook-form).

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const emailRules = {
  required: 'Email is required',
  pattern: {
    value: EMAIL_PATTERN,
    message: 'Enter a valid email address',
  },
};
